import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import paths from '../../paths';
import { getFullGalleryImageUrl } from '../../utils/api/services/image';

export class GalleryCategoryItem extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        alias: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired
    }

    render() {
        const {
            name, alias, image
        } = this.props;
        return (
            <Link to={`${paths.advocates.gallery}/${alias}`} className="gallery-main__item">
                <div className="gallery-main__item-pic -m">
                    <img src={getFullGalleryImageUrl(image)} />								
				</div>
                <div className="gallery-main__item-desc">
                    <div className="gallery-main__item-title">
                        {name}
								</div>
                </div>	
            </Link>
        );
    }
}